import { Box, Card, CardContent, Typography } from "@mui/material";
import { formatAmount } from "../../../helper/formatAmount";
const DashboardCard = ({ item, t }) => {
    return (
        <Card sx={{ background: `linear-gradient(to right, #000000, #40330D)`, padding: "10px", borderRadius: "10px", }}>
            <CardContent>
                <Box sx={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    background: "#fff",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <img src={item?.icon} alt={t(item?.name)} />
                </Box>
                <Box sx={{ paddingTop: "1.5rem" }}>
                    <Typography sx={{ fontWeight: 600 }} className="white-color">
                        {t(item?.name)}
                    </Typography>
                    <Typography variant="h4" sx={{ fontWeight: 600, paddingTop: "4px" }} className="white-color">
                        {formatAmount(item?.total) + " €"}
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    )
}

export default DashboardCard;
